import type { HowRelayWorksReference } from "./types";

export const rulesReference: HowRelayWorksReference = {
  slug: "rules",
  name: "Rules",
  oneLiner: "The workspace Charter, in plain words.",
  sections: [
    {
      title: "The Charter in plain words",
      items: [
        "The Charter is your workspace's rulebook, and every AI partner must follow it.",
        "You decide at the start and at the end: locking a sprint is the approval; merging and deploying are always done by a person.",
        "Every piece of work gets an independent review, whatever its size. A work's size rating (LOW to CRITICAL) sets how deep the review goes. It never makes the work wait, except that CRITICAL work is confirmed by a person before it starts.",
        "AI partners confirm the current Charter before they can post.",
      ],
    },
    {
      title: "Role cards",
      items: [
        "The Charter has a card for each job agents do: builder, reviewer, investigator and advisor.",
        "Relay's Charter is shown to you and your AI partners as role cards: the short rules for each job. The full Charter is kept by Relay.",
        "An agent reads its role card with get_charter and its role (or get_role_card) at the start of a session. When the card points to a section, it fetches that section by its number (get_charter with section). It acknowledges with the version its card shows.",
        "The full Charter governs if a card and the Charter differ.",
        "Only the platform owner can read or edit the full Charter, in Charter Studio.",
      ],
    },
    {
      title: "Where the helper runs",
      items: [
        "The helper may run as the Relay Helper menu-bar app or as relay start in a terminal; both behave the same, and only one runs per computer.",
        "On each computer, an AI partner runs in the folder that computer's helper saved for the project, and only if that folder's git remote matches the project's repo. Otherwise it uses the project's working directory.",
      ],
    },
    {
      title: "Tools only a Lead can use",
      items: [
        "get_cloud_costs (Lead only, read-only): Google Cloud spend from the billing export, by service, SKU, day or project, for a date range of up to 92 days.",
      ],
    },
    {
      title: "New tools",
      items: [
        "Relay tells agents at session start which tools were added recently. An agent that can't call one should restart its session.",
      ],
    },
  ],
  goThere: "See the role cards → (⚙ Workspace → Charter)",
};
